export enum LevelSubScreen {
  GENERAL = 'General',
  TIMELINE = 'Timeline',
  TIMES = 'Times',
  EVENTS = 'Events',
  PERFORMANCE = 'Performance',
  VERSIONS = 'Versions',
  LINKS = 'Links',
  DOCUMENTS = 'Documents',
}

export enum LevelSubScreenLink {
  GENERAL = 'general',
  TIMELINE = 'timeline',
  TIMES = 'times',
  EVENTS = 'events',
  PERFORMANCE = 'performance',
  VERSIONS = 'versions',
  LINKS = 'links',
  DOCUMENTS = 'documents',
}

export enum Perspective {
  PART = 'part',
  BATCH = 'batch',
  NC_FILE = 'nc-file',
  JOBS = 'jobs',
  TOOLS = 'tools',
  ORDER = 'order',
}

export enum ModalType {
  PART = 'partModal',
  BATCH = 'batchModal',
  NC_FILE = 'ncFileModal',
  ORDER = 'orderModal',
  JOBS = 'jobsModal',
  TOOLS = 'toolsModal',
}

export enum LevelScreen {
  PART = 'Part',
  JOB = 'Jobs',
  ORDER = 'ProductionOrder',
  BATCH = 'Batch',
  NC_FILE = 'NCFile',
  TOOLS = 'Tools',
}

export enum DetailsScreenLevelTitle {
  PART = 'Part',
  JOBS = 'Jobs',
  BATCH = 'Batch',
  NC_FILE = 'NC File',
  ORDER = 'Production Order',
  TOOLS = 'Tools',
}
export enum NcFileBatchEventType {
  CYCLE = 'Cycle',
  ACTIVE = 'Active',
  CHANGE = 'Change',
  SETUP = 'Setup',
  TRACE = 'Trace',
}

export enum NcFileBatchEventsLink {
  CYCLE = 'cycle',
  ACTIVE = 'active',
  SETUP = 'setup',
  CHANGE = 'change',
  TRACE = 'trace',
}
